import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { Patient } from '@pixacare/domain';
import { DialogService } from 'src/app/services/dialog.service';
import { patientsActions } from 'src/app/shared/store/patients/patients.actions';
import { PatientCreateComponent } from '../../patient/patient-create/patient-create.component';

@Injectable({
  providedIn: 'root',
})
export class PatientCreationService {
  private readonly dialogService = inject(DialogService);
  private readonly store = inject(Store);
  private readonly translocoService = inject(TranslocoService);

  createPatient(clientCode: string): void {
    this.dialogService
      .openComponent(PatientCreateComponent, {
        label: this.translocoService.translate('Créer un patient'),
        size: 'l',
        data: {
          clientCode,
        },
      })
      .subscribe((patient: Patient) => {
        if (!patient) {
          return;
        }

        this.store.dispatch(
          patientsActions.createPatient({
            clientCode,
            patient,
          }),
        );
      });
  }
}
